import React from 'react'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { currentOffsetStep } from 'src/features'
import { Divider, Row, Col, Button, Steps, Tooltip } from 'antd'
import { ArrowLeftOutlined, ArrowRightOutlined, ReloadOutlined } from '@ant-design/icons'
const { Step } = Steps

interface OffsetByExcelStepsProps {
  nextStepValue: number,
  beforeStepValue?: number,
  loading?: boolean
  handleSubmitClick?: any
  handleBackClick?: any
  isNextButtonDisabled?: boolean
  isLastStep?: boolean
  showTooltipError?: boolean
  tooltipLabel?: string
}

const OffsetByExcelSteps: React.FC<OffsetByExcelStepsProps> = (props) => {
  const { t } = useTranslation()
  const {
    nextStepValue, beforeStepValue = null,
    loading = false, handleSubmitClick = null,
    handleBackClick = null, isNextButtonDisabled = false,
    isLastStep = false, showTooltipError = false, tooltipLabel = ''
  } = props

  const currentStep: number = useAppSelector(currentOffsetStep)

  const getNextButtonText = () => {
    const steps = {
      '1': 'card.Continue',
      '2': 'developers.OffSet.VerifyFields',
      '3': 'developers.OffSet.MakePurchases',
    }
    if (loading) return t('developers.OffSet.MakingPurchases')
    return t(steps[nextStepValue])
  }

  const getNextButton = () => {
    return (
      <Button
        type='primary'
        htmlType='button'
        loading={loading}
        className='float-right radius-100'
        icon={<ArrowRightOutlined />}
        onClick={handleSubmitClick}
        disabled={isNextButtonDisabled}
        size={'large'}
      >
        {getNextButtonText()}
      </Button>
    )
  }

  return (
    <>
      <Steps current={currentStep}>
        <Step title={t('developers.OffSet.ExcelFile')} />
        <Step title={t('developers.OffSet.ChooseKeys')} />
        <Step title={t('developers.OffSet.MakePurchases')} />
        <Step title={t('developers.OffSet.ViewResults')} />
      </Steps>
      <Divider />
      <Row>
        {beforeStepValue !== null ? (
          <Col xs={12} lg={12}>
            <Button
              type='default'
              className='radius-100'
              icon={isLastStep ? <ReloadOutlined /> : <ArrowLeftOutlined />}
              size={'large'}
              onClick={handleBackClick}
            >
              {isLastStep ? t('developers.OffSet.MakeNewOffset') : t('card.Back')}
            </Button>
          </Col>
        ) : (
          <Col xs={12} lg={12} />
        )}
        <Col xs={12} lg={12}>
          {handleSubmitClick && (
            <>
              {showTooltipError ? (
                <Tooltip title={tooltipLabel} color={'red'}>
                  {getNextButton()}
                </Tooltip>
              ) : <>{getNextButton()}</>}
            </>
          )}
        </Col>
      </Row>
    </>
  )
}

export default OffsetByExcelSteps
